"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryString;

function getQueryString() {
  try {
    var search = sessionStorage.getItem('wordpress-search') || location.search;
    sessionStorage.setItem('wordpress-search', search);
    return search;
  } catch (e) {
    return '';
  }
}

module.exports = exports.default;